import styled from 'styled-components';

export const PasswordFieldContainerStyled = styled.div`
  display: flex;
  font-family: InspireTWDC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;

  input {
    font-family: InspireTWDC;
  }

  & > div {
    width: 100%;
  }
`;

export const TextFieldContainerStyled = styled(PasswordFieldContainerStyled)`
  margin-bottom: ${({ theme }): string => theme.spacers!.spacer04};
`;

export const ElementWrapper = styled.div`
  font-family: InspireTWDC;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const StyledBottomContent = styled(ElementWrapper)`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-align: center;

  & > div {
    margin: ${({ theme }): string => theme.spacers!.spacer03} 0;
  }
`;

export const FormWrapper = styled.div`
  max-width: 390px;
  width: 390px;
  color: ${({ theme }): string => theme.admanColors!.gray.dark.bg3[0]};

  input:-webkit-autofill {
    animation-name: autofill;
    animation-duration: 0.1s;
  }

  @keyframes autofill {
    from {
    }

    to {
    }
  }
`;
